<template>
  <div class="modal fade" id="serviceNotAddedPopup">
    <div class="modal-dialog">
      <div class="modal-content p-20">
        <div class="text-right">
          <div class="cursor-pointer">
            <img
              src="../../../public/static/images/icons/close_icon.svg"
              class="small"
              alt="close-icon"
              data-dismiss="modal"
              data-target="#serviceNotAddedPopup"
            />
          </div>
        </div>
        <div class="text-center">
          <div class="text-center">
            <img
              src="../../../public/static/images/icons/expiring_soon.svg"
              alt="expiringsoon-icon"
            />
          </div>
            <p class="title pt-20 pb-40">
              This service is not available as you are not subscribed.
            </p>
        </div>
        <div class="row">
          <div class="text-center">
            <button class="ok-btn emergo-green-button mb-5" data-dismiss="modal"
            data-target="#serviceNotAddedPopup">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'serviceNotAddedPopup',
};
</script>
<style scoped lang="scss">
.modal-content {
  background: $white;
  border-radius: $radius10;
}

img {
  width: 48px;
  height: 48px;
  border-radius: $radiusper50;
  &.small {
    width: 24px;
    height: 24px;
  }
}

.ok-btn {
  width: 160px;
  height: 36px;
}

p {
  &.title {
    font-size: $font-24;
    font-weight: $font-weight-normal;
    line-height: 28px;
    color: $dark-black-alpha;
  }
}
</style>
